import { useState } from "react";
import CrudTable from "@/components/CrudTable";
import { MODULES } from "@/config/modules";
import { useLookups } from "@/hooks/useLookups";
import { Rocket, Warning } from "@phosphor-icons/react";

export default function Batches() {
  const { lists, nameMap } = useLookups();
  const [rows, setRows] = useState([]);

  const notReady = rows.filter((b) => !b.launch_ready && b.status === "Upcoming");
  const lowOcc = rows.filter((b) => Number(b.occupancy || 0) < 75 && b.status !== "Completed" && b.status !== "Cancelled");

  const header = (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="rounded-lg bg-white border border-slate-200 p-4 flex items-center gap-3">
        <div className="h-11 w-11 rounded-lg bg-emerald/10 flex items-center justify-center"><Rocket size={22} weight="fill" className="text-emerald" /></div>
        <div>
          <div className="font-heading text-2xl font-extrabold text-navy">{rows.filter((b) => b.launch_ready).length}</div>
          <div className="text-xs text-slate">Batches launch-ready (Material + Onboarding)</div>
        </div>
      </div>
      <div className="rounded-lg bg-white border border-slate-200 p-4 flex items-center gap-3">
        <div className="h-11 w-11 rounded-lg bg-rose/10 flex items-center justify-center"><Warning size={22} weight="fill" className="text-rose" /></div>
        <div>
          <div className="font-heading text-2xl font-extrabold text-navy">{lowOcc.length}</div>
          <div className="text-xs text-slate">Batches below 75% occupancy{notReady.length ? ` · ${notReady.length} not launch-ready` : ""}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div data-testid="batches-page">
      <CrudTable resource="batches" config={MODULES.batches} lists={lists} nameMap={nameMap} onData={setRows} extraHeader={header} />
    </div>
  );
}
